module.exports = __webpack_public_path__ + "static/media/Diner Waitress.29523b44.jpg";